import { Button, Flex, Typography } from "antd";
import { type FC } from "react";
import { useTranslation } from "react-i18next";
import "../../styles.less";
import UseAutozoneNetworkCalls from "../../utils/UseAutozoneNetworkCalls";
import DrawerData from "./DrawerData";
import { formatTranslation } from "../../../../shared/utils/translationUtils";
import { CloseOutlined } from "@ant-design/icons";

interface AutozonesDrawerProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  fieldId: string;
  loading?: boolean;
}

const AutozonesDrawer: FC<AutozonesDrawerProps> = ({
  visible,
  setVisible,
  fieldId,
}) => {
  const { t } = useTranslation();
  const onClose = (): void => {
    setVisible(false);
  };

  UseAutozoneNetworkCalls(visible, fieldId);
  const { Text } = Typography;
  return (
    <>
      {visible && (
        <div
          className="field-operations-container autozones-drawer-main soil-analysis-drawer "
          data-testid="soil-analysis-drawer"
        >
          <Flex
            justify="space-between"
            align="center"
            className="drawer-header"
          >
            <Text strong className="drawer-title">
              {formatTranslation(t("autozones.drawer.autozoneLayer"))}
            </Text>

            <Button
              type="text"
              className="drawer-close-button"
              aria-label={formatTranslation(t("soil.closeSoilAnalysisDrawer"))}
              icon={<CloseOutlined />}
              onClick={onClose}
            />
          </Flex>
          {<DrawerData fieldId={fieldId} onClose={onClose} />}
        </div>
      )}
    </>
  );
};

export default AutozonesDrawer;
